import { motion } from 'framer-motion';
import { FaHeart, FaEye } from 'react-icons/fa';
import { useProjectStats } from '../hooks/useProjectStats';

const ProjectStats = ({ projectId }) => {
  const { stats, loading, toggleLike } = useProjectStats(projectId);

  if (loading) {
    return (
      <div className="flex items-center gap-4 text-gray-400">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 bg-gray-700 animate-pulse rounded"></div>
          <span className="w-8 h-4 bg-gray-700 animate-pulse rounded"></span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 bg-gray-700 animate-pulse rounded"></div>
          <span className="w-8 h-4 bg-gray-700 animate-pulse rounded"></span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4">
      {/* Like Button */}
      <motion.button
        onClick={toggleLike}
        className="flex items-center gap-2 group"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <motion.div
          animate={stats.liked ? { scale: [1, 1.3, 1] } : {}}
          transition={{ duration: 0.3 }}
        >
          <FaHeart
            className={`text-lg transition-all ${
              stats.liked
                ? 'text-red-500 fill-current'
                : 'text-gray-400 group-hover:text-red-400'
            }`}
          />
        </motion.div>
        <span className={`text-sm font-medium ${stats.liked ? 'text-red-500' : 'text-gray-400'}`}>
          {stats.likes}
        </span>
      </motion.button>

      {/* Views Counter */}
      <div className="flex items-center gap-2 text-gray-400">
        <FaEye className="text-lg" />
        <span className="text-sm font-medium">{stats.views}</span>
      </div>
    </div>
  );
};

export default ProjectStats;
